export default __webpack_public_path__ + "static/gear_w.17fc2eb7036d4cd66932e3c84e7fc1d3.png";